var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, delay, put } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import { SnackBarStatuses } from '../type';
import errorMapper from './errorMapper';
function sagaFactory(sagaName, action, apiCall, dataName, options) {
    function newSaga(sagaAction) {
        var _a, payload, next, res, err_1, message;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = sagaAction || {}, payload = _a.payload, next = _a.next;
                    if (!(options === null || options === void 0 ? void 0 : options.delay)) return [3 /*break*/, 2];
                    return [4 /*yield*/, delay(options.delay)];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 5, , 9]);
                    return [4 /*yield*/, call(apiCall, payload)];
                case 3:
                    res = _c.sent();
                    if (typeof ((_b = res.data) === null || _b === void 0 ? void 0 : _b[dataName]) === 'undefined') {
                        throw new Error("".concat(sagaName, " error, ").concat(dataName, " isn't exist"));
                    }
                    next === null || next === void 0 ? void 0 : next(res.data[dataName]);
                    return [4 /*yield*/, put({
                            type: action.type.SUCCESS,
                            payload: res.data[dataName],
                        })];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 5:
                    err_1 = _c.sent();
                    message = err_1.message;
                    console.error(sagaName, message || err_1);
                    if (!(options === null || options === void 0 ? void 0 : options.showSnackError)) return [3 /*break*/, 7];
                    return [4 /*yield*/, put(actions.addSnackBar.request({
                            type: SnackBarStatuses.ERROR,
                            message: errorMapper(message),
                        }))];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7:
                    next === null || next === void 0 ? void 0 : next(false, message);
                    return [4 /*yield*/, put({
                            type: action.type.FAILED,
                        })];
                case 8:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }
    return newSaga;
}
export default sagaFactory;
//# sourceMappingURL=sagaFactory.js.map